
import _Vue from "vue";

export default class CopyPaste {
    execute(text: string): boolean {
        if (((window as any).clipboardData || {}).setData) {
            // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
            return (window as any).clipboardData.setData("Text", text);
    
        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            }
            catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            }
            finally {
                document.body.removeChild(textarea);
            }
        }
        return false;
    }
}